var data = {
  "body": "<path class=\"clr-i-outline clr-i-outline-path-1\" d=\"M25 12V9.05a7 7 0 1 0-14 0v7a1 1 0 0 0 2 0V14h8v-2h-8V9.05a5 5 0 1 1 10 0V16a1 1 0 1 0 2 0v-2h5v18H6V14h3v-2H4v20.09A1.91 1.91 0 0 0 5.91 34h24.18A1.91 1.91 0 0 0 32 32.09V12z\" fill=\"currentColor\"/>",
  "width": 36,
  "height": 36
};
exports.__esModule = true;
exports.default = data;